import { createFileRoute } from '@tanstack/react-router'
import {UserProfile} from "@descope/react-sdk";
import { usePageTitle } from '../../features/page-title/pageTitle'

export const Route = createFileRoute('/me/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Profile')
  return <UserProfile
	  widgetId="user-profile-widget"
  />
}
